
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.892 4c-1.263 0-2.52.498-3.47 1.491-1.898 1.986-1.895 5.167 0 7.155l6.921 7.267c.335.352.968.352 1.304 0 2.31-2.418 4.618-4.84 6.93-7.258 1.897-1.986 1.897-5.168 0-7.155a4.796 4.796 0 00-6.95 0L12 6.147l-.628-.656A4.8 4.8 0 007.892 4zm0 1.772c.78 0 1.56.322 2.176.966l1.284 1.341c.336.352.969.352 1.304 0l1.275-1.331c1.232-1.29 3.11-1.29 4.342 0 1.231 1.288 1.231 3.372 0 4.66-2.093 2.19-4.181 4.384-6.274 6.574l-6.273-6.574c-1.23-1.29-1.24-3.381-.01-4.67a3.085 3.085 0 012.176-.966z","fill":"currentColor"}})])
          )
        }
      }
    